import React, { useContext } from "react";
import { RefType } from "../../types";
import { StoreContext } from "../context/Store";
import Button from "../parts/Button";
import Text from "../parts/Text";
import TextArea from "../parts/TextArea";
import { scrollTo } from "../utils";

export interface AboutProps {
  scrollTo: RefType;
}

export interface AboutState {}

export const About = React.forwardRef<HTMLDivElement, AboutProps>(
  (props, ref) => {
    const store = useContext(StoreContext);
    const { about, setAbout } = store;
    const goNext = () => {
      scrollTo(props.scrollTo);
    };
    return (
      <section id="about" className="mb-5" ref={ref}>
        <Text tag="h2" color="pink" classes="mb-5">
          Krótko o Tobie
        </Text>
        <Text tag="p">Czas na podsumowanie!</Text>
        <Text tag="h4" classes="mb-2" color="blue">
          Spróbuj zareklamować siebie jednym zdaniem,
        </Text>
        <Text tag="p" classes="mb-5">
          by potencjalny pracodawca chciał przeczytać Twoje CV do końca, np.:
        </Text>
        <Text tag="p" classes="mb-5">
          <span className="font-italic">
            „Studentka polonistyki uwielbiająca literaturę piękną i kawę chętnie
            popracuje na pół etatu w księgarnio-kawiarni”
          </span>{" "}
          albo
        </Text>
        <Text tag="p" classes="mb-5">
          <span className="font-italic">
            „Student z doświadczeniem w wolontariacie, który lubi pracę
            zespołową, chętnie dołączy do kolejnego projektu”.
          </span>
        </Text>
        <Text tag="p" classes="mb-5">
          Na pewno coś wymyślisz.
        </Text>
        <TextArea
          label="O mnie"
          value={about}
          name="about-me"
          onChange={setAbout}
        />
        <div className="d-flex justify-content-end">
          <div className="col-auto">
            <Button onClick={goNext} classes="pink smaller-text">
              dalej
            </Button>
          </div>
        </div>
      </section>
    );
  }
);

export default About;
